import type { VenueTab } from "@arena/shared";

export function tabBusinessToday(now = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: "America/Sao_Paulo", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(now);
  return ["year", "month", "day"].map(key => parts.find(part => part.type === key)!.value).join("-");
}

export function isPendingStandalone(tab: VenueTab, today: string): boolean {
  const date = tab.standaloneDate ?? tab.openedDate;
  return !date || date < today;
}

export function hasStandaloneNumber(tab: VenueTab): boolean {
  return Number.isSafeInteger(tab.standaloneNumber) && Number(tab.standaloneNumber) > 0 && /^\d{4}-\d{2}-\d{2}$/.test(tab.standaloneDate ?? "");
}

export function standaloneTabTitle(tab: VenueTab): string {
  return hasStandaloneNumber(tab) ? `Comanda ${tab.standaloneNumber}` : "Comanda avulsa";
}

export function standaloneTabReference(tab: VenueTab): string {
  // A date-only value is not a UTC instant: do not shift it with the device's timezone.
  return hasStandaloneNumber(tab) ? tab.standaloneDate!.split("-").reverse().join("/") : `Anterior à numeração · #${tab.id.slice(0, 8).toUpperCase()}${tab.openedDate ? ` · ${tab.openedDate.split("-").reverse().join("/")}` : ""}`;
}

export function matchesStandaloneTab(tab: VenueTab, query: string): boolean {
  const normalize = (value: string) => value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase("pt-BR");
  const term = normalize(query).trim().replace(/^#/, "");
  if (!term) return true;
  return normalize(`${standaloneTabTitle(tab)} ${tab.customerName} ${standaloneTabReference(tab)}`).includes(term);
}
